import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private isLoading = false;
    private count = 0;

    constructor() {
    }

    requestStart(): void {
        if (this.count === 0) {
            this.setLoading(true);
        }
        this.count++;
    }

    requestStop(): void {
        this.count--;
        if (this.count <= 0) {
            this.count = 0;
            this.setLoading(false);
        }
    }

    private setLoading(visible: boolean): void {
        this.isLoading = visible;
    }

    get loading(): boolean {
        return this.isLoading;
    }
}
